var barLang = jQuery('html')[0].lang;

switch( barLang ){
	case 'es':

		jQuery.extend(jQuery.validator.messages, {
		    required: "Este campo es obligatorio.",
			remote: "Por favor, rellena este campo.",
			email: "Por favor, escribe una dirección de correo válida.",
			url: "Por favor, escribe una URL válida.",
			date: "Por favor, escribe una fecha válida.",
			dateISO: "Por favor, escribe una fecha (ISO) válida.",
			number: "Por favor, escribe un número válido.",
			digits: "Por favor, escribe sólo dígitos.",
			creditcard: "Por favor, escribe un número de tarjeta válido.",
			equalTo: "Por favor, escribe el mismo valor de nuevo.",
			extension: "Por favor, escribe un valor con una extensión aceptada.",
			maxlength: jQuery.validator.format( "Por favor, no escribas más de {0} caracteres." ),
			minlength: jQuery.validator.format( "Por favor, no escribas menos de {0} caracteres." ),
			rangelength: jQuery.validator.format( "Por favor, escribe un valor entre {0} y {1} caracteres." ),
			range: jQuery.validator.format( "Por favor, escribe un valor entre {0} y {1}." ),
			max: jQuery.validator.format( "Por favor, escribe un valor menor o igual a {0}." ),
			min: jQuery.validator.format( "Por favor, escribe un valor mayor o igual a {0}." ),
			nifES: "Por favor, escribe un NIF válido.",
			nieES: "Por favor, escribe un NIE válido.",
			cifES: "Por favor, escribe un CIF válido."
		});

		break;

	case 'en-US':

		jQuery.extend(jQuery.validator.messages, {
		    required: "This field is required",
			email: "Please, write a valid email address.",
			url: "Please, write a valid url.",
			date: "Please, write a valid date.",
			number: "Please, write a valid number.",
			digits: "Please, write digits only.",
			creditcard: "Please, write a valid credit card number.",
			equalTo: "Please, write again the same value.",
			extension: "Please, write a value with an accepted extension.",
			maxlength: jQuery.validator.format( "Please, do not write more than {0} characters." ),
			minlength: jQuery.validator.format( "Please, do not write less than {0} characters." ),
			rangelength: jQuery.validator.format( "Please, write a value with a more than {0} and less than {1} characters." ),
			range: jQuery.validator.format( "Please, write a value between {0} and {1}." ),
			max: jQuery.validator.format( "Please, write a value less than or equal to {0}." ),
			min: jQuery.validator.format( "Please, write a value greater than or equal to {0}." ),
			nifES: "Please, write a valid NIF.",
			nieES: "Please, write a valid NIE.",
			cifES: "Please, write a valid CIF."
		});

		break;
}